// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_jw-0";
export var animationContainer = "_jw-1";
export var itemPrice = "_jw-a";
export var itemizedContent = "_jw-9";
export var itemizedHeader = "_jw-7";
export var itemizedRow = "_jw-8";
export var itemizedSection = "_jw-6";
export var modalContent = "_jw-2";
export var orderName = "_jw-3";
export var refundOption = "_jw-4";
export var refundOptionsContainer = "_jw-5";
export var shippingLabel = "_jw-b";
export var totalRow = "_jw-c";